/****************************************************************************
 * Copyright 2020 EPAM Systems
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ***************************************************************************/
const schema = {
  id: '/SimpleObject',
  type: 'object',
  allOf: [
    {
      properties: {
        type: {
          enum: ['simpleObject']
        },
        data: { $ref: '#/definitions/simpleObject' }
      },
      required: ['type', 'data']
    }
  ],
  definitions: {
    simpleObject: {
      type: 'object',
      properties: {
        mode: {
          type: 'string'
        },
        pos: {
          type: 'array',
          items: [
            {
              type: 'object',
              properties: {
                x: {
                  type: 'integer'
                },
                y: {
                  type: 'integer'
                }
              },
              required: ['x', 'y']
            }
          ]
        }
      },
      required: ['type', 'mode', 'pos']
    }
  }
}

export default schema
